<template>
    <div class="user-stat-page-container">
        <div v-if="loading" class="d-flex justify-content-center m-2 tip_body" style="height: 10px;">
            <CSpinner
                color="info"
                style="width:4rem;height:4rem;"
            />
        </div>
        <CCard v-else bodyWrapper class="tip_body">
            <div class="username">
                <div class="d-flex" style="color: blue; font-weight: 600;">
                    <Avatar 
                        :key="stat.userAvatar"
                        :size="55"
                        :src="stat.userAvatar"
                        :username="stat.userName"
                        :userId="stat.userId"
                    />
                    &nbsp;<p class="next_avatar_name_p">{{ stat.userName}}</p>
                </div>
            </div>
            <div class="stat">
                <!-- <div class="sub_stat"> -->
                
                <div class="tips">
                    <div>{{ $t('Tips') }}</div>
                    <div>{{ total_stat.total_tips}}<span v-if="userId == 0">({{ real_stat.total_tips }})</span></div>
                </div>
                <div class="profit-pts">
                    <div>{{ $t('Profit PTs') }}</div>
                    <div :class="{
                        'limegreen': total_stat.profit_pts >= 0,
                        'red': total_stat.profit_pts < 0}">
                        {{ total_stat.profit_pts}}
                        <span  v-if="userId == 0" :class="{
                            'limegreen': real_stat.profit_pts >= 0,
                            'red': real_stat.profit_pts < 0}">
                            ({{ real_stat.profit_pts }})
                        </span>
                    </div>                    
                </div>
                <div class="roi">
                    <div>{{ $t('ROI %') }}</div>
                    <div :class="{
                        'limegreen': total_stat.roi >= 0,
                        'red': total_stat.roi < 0}">
                        {{ total_stat.roi}}
                        <span  v-if="userId == 0" :class="{
                            'limegreen': real_stat.roi >= 0,
                            'red': real_stat.roi < 0}">
                            ({{ real_stat.roi }})
                        </span>
                    </div>
                </div>
                <div class="w-rate">
                    <div>{{ $t('W/Rate') }}</div>
                    <div :class="{
                        'limegreen': total_stat.w_rate >= 0,
                        'red': total_stat.w_rate < 0}">
                        {{ total_stat.w_rate}}
                        <span  v-if="userId == 0" :class="{
                            'limegreen': real_stat.w_rate >= 0,
                            'red': real_stat.w_rate < 0}">
                            ({{ real_stat.w_rate }})
                        </span>
                    </div>
                </div>
                <div class="avg_odd">
                    <div>{{ $t('Avg Odd')}}</div>
                    <div>
                        {{ real_stat.avg_odd }}
                       
                    </div>
                </div>
                <div class="followers">
                    <div>Followers</div>
                    <div class="action-box" :key="total_stat.followers + ' ' + stat.followers">
                        <div :class="{
                                'action': true,
                                'selected': userIsFollowed
                            }">
                            {{ total_stat.followers}}
                            <span  v-if="$route.params.userId != loggedInUser.user_id"
                                v-c-tooltip="userIsFollowed ? $t('You already followed this tipster') : $t('Follow this tipster')"
                                @click="handleFollowUser_($route.params.userId, loggedInUser.user_id)">
                                <CIcon name="cil-user-follow" />
                            </span>
                            <span v-else>
                                <CIcon name="cil-user-follow" class="disabled" />
                            </span>
                        </div>
                    </div>
                    
                </div>
                
            </div>
            
            <div class="strategy_name_bar">
                <p class="strategy_name1">Strategy name</p>
                <div class="stat" style="margin-top: 0px">
                    <span class="strategy-name">{{strategy.name}}</span>
                    <div class="followers">
                        <div>Followers</div>

                        <div class="action-box" :key="total_stat.followers + ' ' + stat.followers">
                            <div :class="{
                                'action': true,
                                'selected': strategyIsFollowed
                            }">
                                {{ stat.followers}}
                                <span  v-if="$route.params.userId != loggedInUser.user_id && strategy.name != 'default'"
                                    v-c-tooltip="strategyIsFollowed ? 'You already followed this strategy' : 'Follow this strategy'"
                                    @click="handleFollowStrategy_(strategy._id)">
                                    <CIcon name="cil-user-follow" />
                                </span>
                                <span v-else>
                                    <CIcon name="cil-user-follow" class="disabled" />
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="d-flex">
                <div class="font-weight-bold">Description:&nbsp;</div>
                <div style="flex: 1">{{ strategy.description }}</div>
            </div>
            <div class="stat stat1">
                <!-- <div class="sub_stat"> -->
                
                <div class="tips">
                    <div>Tips</div>
                    <div>{{ stat.total_tips}}</div>
                </div>
                <div class="profit-pts">
                    <div>Profit PTs</div>
                    <div v-if="stat.profit_pts >= 0" style="color: limegreen;">{{ stat.profit_pts}}</div>
                    <div v-else style="color: red;">{{ stat.profit_pts}}</div>
                </div>
                <div class="roi">
                    <div>ROI %</div>
                    <div v-if="stat.roi >= 0" style="color: limegreen;">{{ stat.roi}}</div>
                    <div v-else style="color: red;">{{ stat.roi}}</div>
                </div>
                <div class="w-rate">
                    <div>W/Rate</div>
                    <div v-if="stat.w_rate >= 0" style="color: limegreen;">{{ stat.w_rate}}</div>
                    <div v-else style="color: red;">{{ stat.w_rate}}</div>
                </div>
                <div class="avg_odd">
                    <div>{{ $t('Avg Odd')}}</div>
                    <div>
                        {{ stat.avg_odd }}                       
                    </div>
                </div>

                <div style="display: flex; align-items: center;">                    
                    <CButton color="success" class="mx-1 detail_button2 strategy_stats_button" @click="handleDetailClick">{{$t('Details')}}</CButton>
                    <CButton color="success" class="mx-1 detail_button2 strategy_stats_button" @click="handleFinancialClick">{{$t('Financial')}}</CButton>
                </div>
                <!-- <div style="display: flex; align-items: center;">                    
                    <CButton color="success" class="mx-1 detail_button2 strategy_stats_button" @click="handleFinancialClick">{{$t('Financial')}}</CButton>
                </div>
                 -->
               
            </div>
             <StatsTableROI 
                :items1="stats1"
                :items2="stats2"
            />
        
        </CCard>
    </div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex';
    import Swal from 'sweetalert2';

    import Avatar from '@/components/Avatar';
    import PostCard from '@/components/PostCard';
    
    import StatsTable from '@/components/StatsTable';
    import StatsTableROI from '@/components/StatsTableROI';

    import commonMixin from '@/mixins/common/commonMixin';
    import tipMixin from '@/mixins/TipMixin';
    import {capitalizeFL} from '@/helpers/string';
    import {displaySuccess} from '@/helpers/message';
    import {convertUTCToLocal, defaultFormat } from '@/helpers/time';

    export default {
        mixins: [commonMixin, tipMixin],
        components: {
            Avatar,
            PostCard,
            StatsTable,
            StatsTableROI
        },
        data () {
            return {
                data: [],
                userId: '',
                stat: {
                    userName: '',
                    total_tips: 0,
                    roi:  0,
                    profit_pts: 0,
                    w_rate: 0,
                    followers: '',
                    resetCount: 0,
                    description: '',
                    avg_odd: 0
                },
                total_stat: {
                    userName: '',
                    total_tips: 0,
                    roi:  0,
                    profit_pts: 0,
                    w_rate: 0,
                    followers: '',
                    resetCount: 0,
                    description: '',
                    avg_odd: 0
                },
                real_stat: {                    
                    total_tips: 0,
                    roi:  0,
                    profit_pts: 0,
                    w_rate: 0,
                    avg_odd: 0
                },
                strategy: {},
                notifications: [],
                stats1: [],
                stats2: [],
                userIsFollowed: false,
                strategyIsFollowed: false
            }
        },
        computed: {
            ...mapGetters(['loggedInUser']),
        },
        methods: {
            ...mapActions([
                'getFeedsByStrategy',
                'getStatsByUserId',
                'getStatsByStrategyId_',
                'postComment',
                'resetTip',
                'toggleLikeTip',
                'toggleFollowTip',
                'toggleFollowUser',
                'toggleFollowStrategy',
                'createStrategy',
                'getStrategies',
                'deleteStrategy',
            ]),
            handleReset() {
                Swal.fire({
                        title: 'Are you sure?',
                        text: "You won't be able to revert this!",
                        icon: 'warning',
                        showCancelButton: true,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        confirmButtonText: 'Yes, reset it!'
                    }).then((result) => {
                        if (result.isConfirmed) {
                            // let user_id = localStorage.getItem('user_id');
                            // this.resetTip({user_id}).then(({status}) => {
                            //     if(status === 'success') {
                            //         this.data = this.data.filter(dItem => dItem.settled === 0 || dItem.type === 'label');
                            //         this.stat = {
                            //             ...this.stat,
                            //             total_tips: 0,
                            //             roi:  0,
                            //             profit_pts: 0,
                            //             w_rate: 0,
                            //             resetCount: this.stat.resetCount + 1
                            //         };
                            //     }
                            // });
                        }
                    })
            },
            init() {
                this.runTimer();
                const {id, notifications, userId} = this.$route.params;
                if(notifications) {
                    this.notifications = notifications.slice();
                }
                
                this.data = [];
                this.getFeedsByStrategy({id: id, userId: userId}).then(({data: {feeds, stat, strategy, total_stat, stat1, userIsFollowed, strategyIsFollowed}}) => {
                    this.strategy = strategy;
                    this.userIsFollowed = userIsFollowed;
                    this.strategyIsFollowed = strategyIsFollowed;
                    this.stat = {
                        ...this.stat,
                        userId: parseInt(stat.user[0]._id),
                        userName: stat.user[0].alias,
                        userAvatar: stat.user[0].avatar,
                        followers: stat.followers,
                        resetCount: stat.resetCount
                    }
                    this.total_stat = {
                        ...this.total_stat,
                        userId: parseInt(stat.user[0]._id),
                        userName: total_stat.user[0].alias,
                        userAvatar: total_stat.user[0].avatar,
                        followers: total_stat.followers,
                        resetCount: total_stat.resetCount
                    }
                    if(stat.totalCount) {
                        this.stat = {
                            ...this.stat,
                            total_tips: stat.totalCount,
                            roi:  stat.stakeTotal ? (stat.profitPTS / stat.stakeTotal * 100).toFixed(2) : 0,
                            profit_pts: stat.profitPTS.toFixed(2),
                            w_rate: stat.settledLose + stat.settledWin ? ((stat.settledWin / (stat.settledLose + stat.settledWin)) * 100).toFixed(2) : 0,
                            avg_odd: stat.settledLose + stat.settledWin ? ((stat.totalOdd / (stat.settledLose + stat.settledWin))).toFixed(2) : 0,
                        };
                    }
                    if(total_stat.totalCount) {
                        this.total_stat = {
                            ...this.total_stat,
                            total_tips: total_stat.totalCount,
                            roi:  total_stat.stakeTotal ? (total_stat.profitPTS / total_stat.stakeTotal * 100).toFixed(2) : 0,
                            profit_pts: total_stat.profitPTS.toFixed(2),
                            w_rate: total_stat.settledLose + total_stat.settledWin ? ((total_stat.settledWin / (total_stat.settledLose + total_stat.settledWin)) * 100).toFixed(2) : 0,
                            avg_odd: total_stat.settledLose + total_stat.settledWin ? ((total_stat.totalOdd / (total_stat.settledLose + total_stat.settledWin))).toFixed(2) : 0,
                        };
                    }
                    if(stat1.totalCount) {
                        this.real_stat = {
                            ...this.real_stat,
                            total_tips: stat1.totalCount,
                            roi:  stat1.stakeTotal ? (stat1.profitPTS / stat1.stakeTotal * 100).toFixed(2) : 0,
                            profit_pts: stat1.profitPTS.toFixed(2),
                            w_rate: stat1.settledLose + stat1.settledWin ? ((stat1.settledWin / (stat1.settledLose + stat1.settledWin)) * 100).toFixed(2) : 0,
                            avg_odd: stat1.settledLose + stat1.settledWin ? ((stat1.totalOdd / (stat1.settledLose + stat1.settledWin))).toFixed(2) : 0,
                        };
                    }
                    
                }).finally(() => {
                    this.runTimer(false);
                    /** move scroll to one from notification */
                    const {selected} = this.$route.params;
                    if(selected) {
                        setTimeout(() => {
                            this.$nextTick(() => {
                                var el = document.querySelector(`#id${selected}`);
                                el.scrollIntoView({
                                    behavior: 'smooth',
                                    block: 'center'
                                });
                            });          
                        }, 500);
                    }
                });

                this.initStats();
            },
            create_UUID(){
                var dt = new Date().getTime();
                var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
                    var r = (dt + Math.random()*16)%16 | 0;
                    dt = Math.floor(dt/16);
                    return (c=='x' ? r :(r&0x3|0x8)).toString(16);
                });
                return uuid
            },
            initStats() {
                const {id, userId} = this.$route.params;

                console.log('strategyId', id)
                console.log('userId', userId)
                console.log('this.$route.params', this.$route.params)

                
                this.getStatsByStrategyId_({userId: userId, strategyId: id}).then(({data}) => {
                    this.stats1 = [];
                    this.stats2 = [];
                    
                    for (var i = 0; i < data.data1.length; i++) {
                        var league = data.data1[i];
                        var item = {};
                        
                        if (!league['league_name'])
                            continue
                        // item['league_id'] = league['league_id']
                        
                        item['League'] = league['league_name'];
                        item['Country'] = league['country_name'];
                        
                        if (league['total_matches'] == 0)
                            continue
                        item['Matches'] = parseFloat(league['total_matches']);
                        item['Matches_ids'] = league['total_matches_ids'];
                        item['home'] = parseFloat(league['home_win_percent']);
                        item['draw'] = parseFloat(league['draw_win_percent']);
                        item['away'] = parseFloat(league['away_win_percent']);
                        item['1st Half'] = parseFloat(league['avg_firsthalf_goals_percent']);
                        item['2nd Half'] = parseFloat(league['avg_secondhalf_goals_percent']);
                        item['total'] = parseFloat(league['avg_total_goals_percent']);
                        item['0.5FH'] = parseFloat(league['first_05_percent']);
                        item['1.5FH'] = parseFloat(league['first_15_percent']);
                        item['2.5FH'] = parseFloat(league['first_25_percent']);
                        item['0.5'] = parseFloat(league['full_05_percent']);
                        item['1.5'] = parseFloat(league['full_15_percent']);
                        item['2.5'] = parseFloat(league['full_25_percent']);
                        item['3.5'] = parseFloat(league['full_35_percent']);
                        item['4.5'] = parseFloat(league['full_45_percent']);
                        item['bts'] = parseFloat(league['bts_percent']);
                        item['0~15'] = parseFloat(league['goal_bands_15_percent']);
                        item['16~30'] = parseFloat(league['goal_bands_30_percent']);
                        item['31~45'] = parseFloat(league['goal_bands_45_percent']);
                        item['46~60'] = parseFloat(league['goal_bands_60_percent']);
                        item['61~75'] = parseFloat(league['goal_bands_75_percent']);
                        item['76~90'] = parseFloat(league['goal_bands_90_percent']);
                        item['Home'] = parseFloat(league['fts_h_percent']);
                        item['H Win'] = parseFloat(league['fts_hw_percent']);
                        item['Away'] = parseFloat(league['fts_a_percent']);
                        item['A Win'] = parseFloat(league['fts_aw_percent']);

                        item['home_pt_percent'] = parseFloat(league['home_pt_percent']);
                        item['away_pt_percent'] = parseFloat(league['away_pt_percent']);
                        item['draw_pt_percent'] = parseFloat(league['draw_pt_percent']);
                        item['sh_05_percent'] = parseFloat(league['sh_05_percent']);
                        item['sh_15_percent'] = parseFloat(league['sh_15_percent']);
                        item['sh_25_percent'] = parseFloat(league['sh_25_percent']);
                        item['ht_firstGoal_min_avg'] = parseFloat(league['ht_firstGoal_min_avg']);
                        item['sh_firstGoal_min_avg'] = parseFloat(league['sh_firstGoal_min_avg']);
                        item['roi'] = league['roi'];
                        item["uuid"] = this.create_UUID();
                        this.stats1.push(item);
                        
                    }
                    for (var i = 0; i < data.data2.length; i++) {
                        var league = data.data2[i];
                        var item = {};
                        
                        if (!league['league_name'])
                            continue
                        // item['league_id'] = league['league_id']
                        
                        item['League'] = league['league_name'];
                        item['Country'] = league['country_name'];
                        
                        if (league['total_matches'] == 0)
                            continue
                        item['Matches'] = parseFloat(league['total_matches']);
                        item['Matches_ids'] = league['total_matches_ids'];
                        item['home'] = parseFloat(league['home_win_percent']);
                        item['draw'] = parseFloat(league['draw_win_percent']);
                        item['away'] = parseFloat(league['away_win_percent']);
                        item['1st Half'] = parseFloat(league['avg_firsthalf_goals_percent']);
                        item['2nd Half'] = parseFloat(league['avg_secondhalf_goals_percent']);
                        item['total'] = parseFloat(league['avg_total_goals_percent']);
                        item['0.5FH'] = parseFloat(league['first_05_percent']);
                        item['1.5FH'] = parseFloat(league['first_15_percent']);
                        item['2.5FH'] = parseFloat(league['first_25_percent']);
                        item['0.5'] = parseFloat(league['full_05_percent']);
                        item['1.5'] = parseFloat(league['full_15_percent']);
                        item['2.5'] = parseFloat(league['full_25_percent']);
                        item['3.5'] = parseFloat(league['full_35_percent']);
                        item['4.5'] = parseFloat(league['full_45_percent']);
                        item['bts'] = parseFloat(league['bts_percent']);
                        item['0~15'] = parseFloat(league['goal_bands_15_percent']);
                        item['16~30'] = parseFloat(league['goal_bands_30_percent']);
                        item['31~45'] = parseFloat(league['goal_bands_45_percent']);
                        item['46~60'] = parseFloat(league['goal_bands_60_percent']);
                        item['61~75'] = parseFloat(league['goal_bands_75_percent']);
                        item['76~90'] = parseFloat(league['goal_bands_90_percent']);
                        item['Home'] = parseFloat(league['fts_h_percent']);
                        item['H Win'] = parseFloat(league['fts_hw_percent']);
                        item['Away'] = parseFloat(league['fts_a_percent']);
                        item['A Win'] = parseFloat(league['fts_aw_percent']);

                        item['home_pt_percent'] = parseFloat(league['home_pt_percent']);
                        item['away_pt_percent'] = parseFloat(league['away_pt_percent']);
                        item['draw_pt_percent'] = parseFloat(league['draw_pt_percent']);
                        item['sh_05_percent'] = parseFloat(league['sh_05_percent']);
                        item['sh_15_percent'] = parseFloat(league['sh_15_percent']);
                        item['sh_25_percent'] = parseFloat(league['sh_25_percent']);
                        item['ht_firstGoal_min_avg'] = parseFloat(league['ht_firstGoal_min_avg']);
                        item['sh_firstGoal_min_avg'] = parseFloat(league['sh_firstGoal_min_avg']);
                        item['roi'] = league['roi'];
                        item["uuid"] = this.create_UUID();
                        this.stats2.push(item);
                        
                    }
                    
                });
            },

            handleDetailClick() {
                const {id, userId} = this.$route.params; 
                let routeData = this.$router.resolve({
                    name: 'UserStrategyStat',
                    params: {
                        id: id,
                        userId: userId
                    }
                });
                window.open(routeData.href, '_blank');
            },

            handleStatsClick() {
                const {id, userId} = this.$route.params;
                
                let routeData = this.$router.resolve({
                    name: 'UserStrategyStats',
                    params: {
                        id: id,
                        userId: userId
                    }
                });
                window.open(routeData.href, '_blank');
            },
            handleFinancialClick() {
                const {id, userId} = this.$route.params; 
                let routeData = this.$router.resolve({
                    name: 'UserStrategyFinancial',
                    params: {
                        id: id,
                        userId: userId
                    }
                });
                window.open(routeData.href, '_blank');
            },
        },
        watch: {
            '$route.params': {
                deep: true,
                immediate: true,
                handler(val) {
                    if(!this.loading)
                        this.init();
                }
            }
        },
        mounted() {
            let user_id = localStorage.getItem('user_id');
            this.userId = parseInt(user_id);
           
        },
        created() {
        },
        beforeDestroy() {
            
        }
    }
</script>
<style lang="scss" scoped>
   .user-stat-page-container {
       .stat {
           display: flex;
           justify-content: space-between;
           margin-bottom: 20px;
           div {
               text-align: center;
           }
           .username {
               div {
                   text-align: left;
               }
               .vue-avatar--wrapper {
                    display: inline-flex !important;
                    margin-right: 5px;
                }
           }
       }
       .username{
           ::v-deep .d-flex{
               .parent_avatar{
                   .vue-avatar--wrapper{
                       border: 5px solid white !important;
                   }
               }
           }
       }
       .header {
           .header-item {
                display: flex;
                justify-content: space-between;
                position: relative;
                div {
                    display: flex;
                }
                .settled-lost {
                    font-weight: 700;
                    color: #FF0000;
                }
                .settled-won {
                    font-weight: 700;
                    color: #00FF00;
                }
           }
       }
       .unread-mark {
           top: 0px;
           left: 0px;
       }
       .note-box {
           position: relative;
           margin-bottom: 20px;
           .note {
               padding: 5px;
               margin: 0 0 10px;
               min-height: 70px;
               background-color: #FEE;
               border-radius: 6px;
           }
           .action-box {
               display: flex;
               .action {
                   border-radius: 5px;
                   padding: 0 5px;
                   margin-right: 10px;
                   min-width: 70px;
                   text-align: center;
                   background-color: rgba(0,0,0,0.1);
                   &.selected {
                       background-color: #39F;
                       color: #FFF;
                   }
               }
           }
       }
       .comments {
           padding: 0 0 0 40px;
           .comment {
               position: relative;
               .comment-header {
                   display: flex;
                   align-items: center;
                   .vue-avatar--wrapper {
                       margin-right: 15px;
                   }
               }
                p {
                    padding-left: 45px;
                }
           }
       }
       .post-comment {
           text-align: right;
           margin-bottom: 10px;
           .btn {
           }
       }
    }   
    .c-callout {
        padding: 1rem;
        margin-top: 50px;
        background-color: #eee !important;
    }
    .strategy_name1{
        text-align: center;
        font-weight: 800;
        font-size: 18px;
        margin-bottom: 0;
    }
    .sub_strategy_name_bar{
        height: 50px;
        background-color: cadetblue;
        color: white;
        font-size: 22px;
        text-align: center;
        padding: 6px;
        font-weight: 700;
    }
    .stat{
        background-color: #5f9ea0;
        color: white;
        padding: 5px 100px 5px 140px;
        position: relative;
        margin-top: 40px;
    }
    .username{
        position: absolute;
        top: 32px;
        left: 60px;
        z-index: 1000;
    }
    .tip_body{
        background-color: whitesmoke;
    }

    .limegreen {
        color: limegreen
    }
    .red {
        color: red
    }

    .strategy-name {
        margin: auto;
        font-size: 22px;
        font-weight: bold;
    }
    .stat_button {
        min-width: 100px
    }
  
 
    @media (max-width: 576px){
       .stat{
           padding: 5px !important;
       }
       .username{
        left: 20px;
        top: 32px;

        }
        .stat{
            font-size: 10px !important;
            padding-left: 70px !important;
            padding-right: 10px !important;
        }
        .stat1{
            
            padding-left: 20px !important;
            padding-right: 20px !important;
        }
        .stat > button {
            font-size: 10px;
            padding: 5px !important;
        }
         .strategy-name {            
            font-size: 13px; 
        }
        .stat_button {
            min-width: 60px
        }
    } 

</style>
<style>
    @media (max-width: 576px){
        .strategy_stats_button {
            font-size: 8px;
        }
    }
</style>